export default "__VITE_PUBLIC_ASSET__5e141f9b__"